/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component — the cart lines of the cart BbPanel in the «UI nuova»
 *              (M18 ec-shell): thumbnail, name, dates, price, remove, then the
 *              total with «concludi ordine» (the shop's brand call-to-action)
 *              and «continua con gli acquisti». Rendered by ec-shell-nuova.hbs.
 *   extends:   ListCartProductComponent (./list-cart-product)
 *   template:  list-cart-product-nuova.hbs
 *   args:      @cart, @totCart, @delCart, @applicationController (as the classic)
 *   uses:      -
 *   siblings:  list-cart-product.hbs (classic template, unchanged)
 *   tests:     ui-nuova-ec-shell-test.js
 *   gotchas:   template-only fork: delCart is the inherited @action (forwards
 *              @applicationController, see the classic gotcha on unbound calls).
 */
import ListCartProductComponent from './list-cart-product';

export default class ListCartProductNuovaComponent extends ListCartProductComponent {}
